import { CLASSNAME_FOOTNOTE_LINKS, CLASSNAME_SR_ONLY } from '../constant';
import { trackFootnote } from '../container/App/helpers/tracking';

function footnoteHandler ({ target }: MouseEvent) {
    if (target instanceof HTMLElement) {
        // Offer price contains screen reader only text
        const srElement = target.parentElement
            ?.getElementsByClassName(CLASSNAME_SR_ONLY)[0] as HTMLElement | undefined;
        // Use screen reader text or parent's text with removed footnote number from its end
        const text = srElement?.innerText || target.parentElement?.innerText.slice(0, -1);

        trackFootnote(text || '');
    }
}
/**
 * Adds tracking to all the available footnote links on the page
 */
export const mountFootnotes = () => {
    const footnotes = document.getElementsByClassName(CLASSNAME_FOOTNOTE_LINKS);

    Array.from(footnotes).forEach((element: HTMLElement) => {
        element.removeEventListener('click', footnoteHandler);
        element.addEventListener('click', footnoteHandler);
    });
};

/**
 * Reinit footnotes.
 */
export const reinitFootnotes = () => {
    try {
        window.vf?.footnotes?.init();

        mountFootnotes();
    } catch (err) {
        console.warn('Footnotes cant be initialized', err);
    }
};
